document.addEventListener('click', (e)=>{
    let item = e.target;

    if(item.closest('#searchInput') && item.closest('.rebuy-quick-view-dropdown__input-container') && item.closest('.header__search') ){
        let ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        let overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
        overlay.style.display = 'flex';
    }

    if(item.closest('.rebuy-quick-view-dropdown__close') && item.closest('.rebuy-quick-view-dropdown__input-container') && item.closest('.header__search') ){
        let ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        let overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
        overlay.style.display = 'none';
    }
    
    if (!item.closest('.rebuy-quick-view-dropdown__container') && !item.closest('.header__search')) {
        const ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        if (ancestor) {
            const overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
            if (overlay) overlay.style.display = 'none';
        } else {
            // fallback in case user clicks completely outside
            const overlay = document.querySelector('#rebuy-quick-view-overlay');
            if (overlay) overlay.style.display = 'none';
        }
    }

})

document.addEventListener('rebuy:cart.add', () => { 
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    let cartDrawer = document.querySelector('cart-drawer'); cartDrawer.open();
});